import {
  IntegrationDetailMrnPage,
  IntegrationDetailMrnProps,
} from "~/pages/integrations/IntegrationDetailMrnPage";

const IntegrationDetailMrnEntryPage = ({
  scope,
}: IntegrationDetailMrnProps) => {
  return <IntegrationDetailMrnPage scope={scope} />;
};

export default IntegrationDetailMrnEntryPage;
